interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ kicker, title, desc }: SectionHeadingProps) {
  return (
    <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold tracking-wide text-secondary-800">
          <i className="ri-flashlight-fill text-primary-500" aria-hidden="true"></i>
          {kicker}
        </p>
        <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
    </div>
  );
}